import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output,SimpleChanges } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'lib-searchbox',
  standalone: true,
  imports: [InputTextModule,
    IconFieldModule,InputIconModule],
  templateUrl: './searchbox.component.html',
  styleUrl: './searchbox.component.css'
})
export class SearchboxComponent implements OnChanges {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  data = '';
  // ✅ no constructor needed — ChangeDetectorRef removed
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {       // ✅ guard: only sync when value input changed
      this.data = this.value;
    }
  }
  valueBack(event: Event): void {
    this.data = (event.target as HTMLInputElement).value;
    this.valueChange.emit(this.data);
  }
}
